/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_ExpandInputs */

const en_tree_expand = /** @type {(inputs: Tree_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expand sub-items`)
};

const de_tree_expand = /** @type {(inputs: Tree_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untervorgänge ausklappen`)
};

/**
* | output |
* | --- |
* | "Expand sub-items" |
*
* @param {Tree_ExpandInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tree_expand = /** @type {((inputs?: Tree_ExpandInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_ExpandInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tree_expand(inputs)
	return en_tree_expand(inputs)
});